import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { PublicTableAssetTitle } from "~/components/TableView/NameCell/NameCellContent/PublicTableAssetTitle";
import { BoardMetaData } from "../NameCell/BoardNameCell/BoardMetaData";
export const PublicBoardNameCellTitle = /*#__PURE__*/ memo((param)=>{
    let { onClick, onCmdClick, board } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative ml-3",
        "data-disableselect": "true",
        children: [
            /*#__PURE__*/ _jsx(PublicTableAssetTitle, {
                title: board.title,
                onClick: onClick,
                onCmdClick: onCmdClick
            }),
            /*#__PURE__*/ _jsx(BoardMetaData, {
                itemCount: board.directDescendantCount
            })
        ]
    });
});
PublicBoardNameCellTitle.displayName = "PublicBoardNameCellTitle";
